module.exports = __webpack_public_path__ + "static/CrossChain2-40f127e5979e5e6241bb03396f7d1ea2.png";